import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class Select extends Component {
  static propTypes = {
    updateData: PropTypes.func
  }

  state = {
    selectOpen: false
  }

  componentDidMount = () => {
    window.addEventListener('click', ev => this.clickWindow(ev));
    window.addEventListener('touchstart', ev => this.clickWindow(ev));

    if(localStorage.getItem('rstCode')) {
      this.goToEvent(localStorage.getItem('rstCode'));
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('click', ev => this.clickWindow(ev));
    window.removeEventListener('touchstart', ev => this.clickWindow(ev));
  }

  openSelectList = () => {
    this.setState({selectOpen: !this.state.selectOpen});
  }

  closeSelectList = () => {
    this.setState({selectOpen: false});
  }

  clickWindow = ev => {
    let evTarget = ev.target;
    const selectBtn = document.querySelector('.courses-sort__select-btn');

    while(evTarget !== this.select
      && evTarget !== document.body
      && evTarget !== selectBtn) {

      evTarget = evTarget.parentNode;

      if(evTarget.tagName === 'BODY') {
        this.closeSelectList();
        break;
      }
    }
  }

  getResort = ev => {
    const selectBtn = document.querySelector('.courses-sort__select-btn');
    const {updateData} = this.props;

    selectBtn.innerHTML = ev.target.innerHTML;
    updateData(ev.target.dataset.value);
  }

  goToEvent = rstCode => {
    const selectBtn = document.querySelector('.courses-sort__select-btn');
    const {updateData} = this.props;

    updateData(rstCode);
    let fullName;

    switch(rstCode) {
      case 'BTC':
        fullName = 'Turks & Caicos';
        break;

      case 'BNG':
        fullName = 'Negril';
        break;

      case 'BBO':
        fullName = 'Ocho Rios';
        break;

      default:
        fullName = 'Turks & Caicos';
        break;
    }
    selectBtn.innerHTML = 'Beaches ' + fullName;
    localStorage.removeItem('rstCode');
  }

  render() {
    const {selectOpen} = this.state;

    return(
      <div className="courses-sort__select-wrapper">
        <div
          className="courses-sort__select-btn"
          onClick={this.openSelectList}>Select a resort to view courses</div>
        <div
          id="activities"
          className={'courses-sort__select ' + (selectOpen ? 'courses-sort__select--active' : '')}
          onClick={ev => this.getResort(ev)}
          onTouchStart={ev => this.getResort(ev)}>

          <div
            data-value="BTC"
            className="courses-sort__option">
            Beaches Turks & Caicos
          </div>

          <div
            data-value="BBO"
            className="courses-sort__option">
            Beaches Ocho Rios
          </div>

          <div
            data-value="BNG"
            className="courses-sort__option">
            Beaches Negril
          </div>
        </div>
      </div>
    );
  }
}
